<template>
    <div class="hellovue__language_selection">
        <ul v-if="languages !== undefined && languages.length > 0" :aria-label="$t('hellovue.dropdown.select_language')">
            <li v-for="(lang, index) in languages" :key="index" :id="'language_'+index" :lang="lang">
              <span v-if="getCurrentLanguage === lang"> {{ lang.toUpperCase() }}</span>
              <a v-else @click="changeLanguage(lang)">{{ lang.toUpperCase() }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import { i18n } from "src/translations/i18n";

    export default {
        name: "ChangeLanguage",
        data() {
            return {
                languages: {}
            }
        },
        computed: {
            getCurrentLanguage() {
                return i18n.locale
            }
        },
        methods: {
            changeLanguage(lang) {
                if (lang !== i18n.locale) {
                    i18n.locale = lang
                    let routeQuery = {}
                    if (lang === 'sv') {
                        routeQuery.lang = lang
                    }
                    this.$router.push({
                        name: this.$router.currentRoute.name,
                        query: routeQuery
                    })
                }
            }
        },
        mounted() {
            window.addEventListener('load', () => {
                this.languages = ['fi', 'sv']

            })
        }
    }
</script>

<style scoped>

</style>
